import { useState } from "react";
import classNames from "classnames";
import Collapse from "react-bootstrap/Collapse";

const GiftCardExpandable = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className="gift-cards-expandable"
        onClick={() => setOpen(!open)}
      >
        <span className="font-weight-medium">{title}</span>
        <span className={classNames("toggle", open && "expanded")} />
      </div>
      <Collapse in={open}>
        <div className="gift-cards-expandable-content">
          {children}
        </div>
      </Collapse>
    </>
  );
};

export default GiftCardExpandable;
